export default {
  headline: {
    before: 'Ensemble,',
    highlight: 'simplifions',
    after: 'chaque déménagement.',
  },
  intro: 'Un espace de travail unifié pour piloter les opérations et accompagner la performance de nos équipes.',
  homeLabel: 'Nextories One — Connexion',
  fields: {
    identifier: 'Identifiant',
    identifierPlaceholder: 'Votre identifiant',
    password: 'Mot de passe',
    passwordPlaceholder: 'Votre mot de passe',
    email: 'Adresse email',
    emailPlaceholder: 'prenom.nom{\'@\'}nextories.com',
    newPassword: 'Nouveau mot de passe',
    newPasswordPlaceholder: 'Votre nouveau mot de passe',
    confirmation: 'Confirmer le nouveau mot de passe',
    confirmationPlaceholder: 'Saisissez-le à nouveau',
    currentPassword: 'Mot de passe actuel',
  },
  login: {
    title: 'Connexion',
    eyebrow: 'Bienvenue sur Nextories One',
    heading: 'Votre espace de travail.',
    forgot: 'Mot de passe oublié ?',
    submit: 'Accéder à One',
    invalid: 'Identifiant ou mot de passe incorrect.',
  },
  recovery: {
    title: 'Récupération d’accès',
    stepRequest: 'Récupération d’accès · Étape 1 sur 2',
    stepReset: 'Récupération d’accès · Étape 2 sur 2',
    requestHeading: 'Retrouvez votre accès à One.',
    requestDescription: 'Renseignez votre identifiant et l’adresse email associée à votre compte. Vous recevrez un lien pour renouveler votre mot de passe.',
    requestSubmit: 'Recevoir le lien',
    sentHeading: 'Consultez votre messagerie.',
    sentDescription: 'Si les informations correspondent à votre compte, vous recevrez un email contenant le lien pour définir un nouveau mot de passe.',
    sentHelp: 'Vous ne trouvez pas l’email ? Vérifiez vos courriers indésirables ou contactez votre administrateur.',
    again: 'Refaire une demande',
    resetHeading: 'Définissez votre nouveau mot de passe.',
    resetDescription: 'Choisissez un mot de passe personnel d’au moins 8 caractères pour accéder à votre espace One.',
    resetSubmit: 'Enregistrer le mot de passe',
    invalidToken: 'Ce lien n’est plus valide. Refaites une demande pour recevoir un nouveau lien.',
    doneEyebrow: 'Votre accès à One',
    doneHeading: 'Votre mot de passe a été mis à jour.',
    doneDescription: 'Vous pouvez maintenant retrouver votre espace de travail.',
    backToLogin: 'Retour à la connexion',
    goToLogin: 'Revenir à la connexion',
  },
  password: {
    title: 'Mot de passe',
    description: 'Gérez l’accès à votre espace personnel.',
    cardTitle: 'Modifier mon mot de passe',
    demoSaved: 'Démonstration : aucun mot de passe n’a été modifié.',
  },
  mismatch: 'Les deux mots de passe doivent être identiques.',
};
